import { jsx, jsxs } from "react/jsx-runtime";
import { styled } from "@mui/material";
import { BrandclubProductCard } from "../components/BrandclubProductCard/index.js";
import BrandclubLoading from "../components/BrandclubLoading/index.js";
import { ProductGrid } from "./SearchResultsStyles.js";
const Container = styled("div")({});
const SearchProductGrid = ({
  loading,
  products,
  LinkComponent,
  containerWidthOverride,
  onShareClick,
  children
}) => {
  return /* @__PURE__ */ jsx(Container, { children: loading ? /* @__PURE__ */ jsx(BrandclubLoading, { type: "productGrid" }) : /* @__PURE__ */ jsxs(ProductGrid, { className: "grid", containerWidthOverride, children: [
    children,
    products.map((product, idx) => {
      return /* @__PURE__ */ jsx(
        BrandclubProductCard,
        {
          className: "fullsize_responsive",
          LinkComponent,
          onShareClick: (e) => onShareClick(e, product),
          product
        },
        idx
      );
    })
  ] }) });
};
export {
  SearchProductGrid as default
};
//# sourceMappingURL=SearchProductGrid.js.map
